import React, {ReactNode} from 'react';
import {Box, Link as MuiLink, Typography, Button} from '@material-ui/core';
import {Message} from 'epic-diesel-common';
import {Status} from '../../../types';

const CODES = {
    retry: 'epic.affiliate.common.retry_request'
};

interface InfoContainerProps {
    children: ReactNode;
}

interface ErrorBlockProps {
    message?: string;
    retry?: () => void;
}
interface NoDataBlockProps {
    message?: string;
    docsUrl?: string;
}

export interface InfoBlockProps extends ErrorBlockProps, NoDataBlockProps {
    status: Status;
}

const InfoContainer: React.FC<InfoContainerProps> = ({children}: InfoContainerProps) => (
    <Box
        display="flex"
        width="100%"
        flexDirection="column"
        alignItems="center"
        justifyContent="center">
        {children}
    </Box>
);

const ErrorBlock: React.FC<ErrorBlockProps> = ({message = '', retry}: ErrorBlockProps) => {
    return (
        <InfoContainer>
            <Typography>{message}</Typography>
            {retry && (
                <Box m={4}>
                    <Button component="div" color="secondary" variant="outlined" onClick={retry}>
                        <Message code={CODES.retry} />
                    </Button>
                </Box>
            )}
        </InfoContainer>
    );
};

const NoDataBlock: React.FC<NoDataBlockProps> = ({message = '', docsUrl}: NoDataBlockProps) => {
    return (
        <InfoContainer>
            {docsUrl ? (
                <MuiLink underline="none" target="_blank" rel="noopener noreferrer" href={docsUrl}>
                    {message}
                </MuiLink>
            ) : (
                <Typography>{message}</Typography>
            )}
        </InfoContainer>
    );
};

export const InfoBlock: React.FC<InfoBlockProps> = ({
    message,
    status,
    retry,
    docsUrl
}: InfoBlockProps) => (
    <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flex={1}
        height="100%"
        p={5}
        m="auto"
        color="text.secondary"
        textAlign="center"
        clone>
        {status === Status.ERROR ? (
            <ErrorBlock message={message} retry={retry} />
        ) : (
            <NoDataBlock message={message} docsUrl={docsUrl} />
        )}
    </Box>
);
